import React, { FC, useEffect } from 'react'

import { Typography, FNOLPageWrapper } from '@dg-shared'
import { useTranslate, useClaim } from '../../../hooks/shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { useFNOLStyles } from '../shared/styles/useStyles'
import { FNOL_COLLISION_QUESTIONS, FORM_ID, TRANSLATIONS as T } from '../../../constants'
import FormBuilder from '@dg-shared/forms/FormBuilder'

const PageMoreInfo: FC<CommonPageProps> = ({ service, currentState }) => {
  const { classes: FNOLClasses } = useFNOLStyles({})
  const { t } = useTranslate(`${T.COLLISION}.moreDetails`)
  const { handleAnswerClick, clearAnswer } = useClaim(service, currentState)

  useEffect(() => {
    clearAnswer(FNOL_COLLISION_QUESTIONS.DESCRIBE_WHAT_HAPPENED)
  }, [clearAnswer])

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`back`)} breadcrumbsStepPercentage={50}>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <FormBuilder
        id={FORM_ID.MORE_DETAILS}
        classes={FNOLClasses.formContainer}
        submitHandler={({ moreDetails }: Record<string, string>) =>
          handleAnswerClick(
            FNOL_COLLISION_QUESTIONS.DESCRIBE_WHAT_HAPPENED,
            moreDetails,
            Events.NEXT
          )
        }
        optional
      />
    </FNOLPageWrapper>
  )
}

export default PageMoreInfo
